export enum IntegrationType {
  ZAPIER = 'zapier',
  GOOGLE_DRIVE = 'google-drive',
  WHATSAPP = 'whatsapp',
  FACEBOOK = 'facebook',
  INSTAGRAM = 'instagram',
  PHONE_NUMBER = 'phone-number',
  CALDOTCOM = 'caldotcom'
}
